import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["action", "method"]

import { computed, ref, provide, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import ValidationText from "./ValidationText.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SharedForm',
  props: {
    action: {},
    errorMessage: {},
    method: { default: "post" },
    showError: { type: Boolean, default: undefined },
    centeredSubmitButtonSection: { type: Boolean },
    noSubmitButtonGap: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const formRef = ref<HTMLFormElement | null>(null);
const numberOfSubmits = ref(0);
const formValidationResetControl = ref(0);
const isFormValid = ref(true);

const isErrorVisible = computed(() =>
	props.showError !== undefined ? props.showError : numberOfSubmits.value > 0 && !isFormValid.value
);

const defaultErrorMessage = computed(() => {
	const translated = t("shared.form.validationError");
	return props.errorMessage || translated;
});

const updateFormValidity = () => {
	// E-Mail muss über sein Pattern geprüft werden und nicht über typeMismatch, was bei checkValidity() auch stattfindet
	let hasError = false;
	if (formRef.value?.elements) {
		for (const el of formRef.value.elements) {
			const element = el as HTMLFormElement;
			if (element.type === "email" && element.pattern) {
				const hasEmailError = element.validity.patternMismatch || element.validity.valueMissing;
				if (hasEmailError) hasError = true;
			} else {
				const isValid = element.checkValidity();
				if (!isValid) hasError = true;
			}
		}
	}
	return (isFormValid.value = !hasError);
};

onMounted(updateFormValidity);

const handleSubmit = (event: Event) => {
	numberOfSubmits.value += 1;
	if (updateFormValidity()) {
		if (!props.action) {
			event.preventDefault();
		}
		emit("submit", event);
	} else {
		focusFirstInvalidInput();
		event.preventDefault();
	}
};

function focusFirstInvalidInput() {
	if (formRef.value?.elements) {
		const invalidElement = Array.from(formRef.value.elements).find(
			(el) => !(el as HTMLFormElement).checkValidity()
		) as HTMLFormElement;
		invalidElement?.focus();
	}
}

provide("numberOfSubmits", numberOfSubmits);
provide("formValidationResetControl", formValidationResetControl);
provide("hasFormWrapper", true);
provide("updateFormValidity", updateFormValidity);
provide("formRef", formRef);

const resetFormValidation = () => {
	formValidationResetControl.value++;
	numberOfSubmits.value = 0;
};

__expose({
	resetFormValidation,
	formValidationResetControl,
	formRef,
	updateFormValidity,
	numberOfSubmits,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    ref_key: "formRef",
    ref: formRef,
    action: _ctx.action,
    method: _ctx.action && _ctx.method,
    novalidate: "",
    class: "tw",
    onSubmit: handleSubmit
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", {
      class: _normalizeClass(["empty:hidden", { 'm-auto w-full max-w-xs': _ctx.centeredSubmitButtonSection, 'mt-14': !_ctx.noSubmitButtonGap }])
    }, [
      (isErrorVisible.value)
        ? (_openBlock(), _createBlock(ValidationText, {
            key: 0,
            class: _normalizeClass(["mb-2", { 'text-center': _ctx.centeredSubmitButtonSection }]),
            "error-message": defaultErrorMessage.value,
            "no-indent": ""
          }, null, 8, ["class", "error-message"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "submitButton")
    ], 2)
  ], 40, _hoisted_1))
}
}

})